(function () {
  function initKurzbeschreibung(root) {
    (root || document).querySelectorAll('[data-kurzbeschreibung]').forEach(function (wrapper) {
      if (wrapper.dataset.kurzbeschreibungInit === 'true') return;

      const content = wrapper.querySelector('[data-kurzbeschreibung-content]');
      const toggle = wrapper.querySelector('[data-kurzbeschreibung-toggle]');
      if (!content || !toggle) return;

      const expandLabel = wrapper.getAttribute('data-expand-label') || 'Weiterlesen';
      const collapseLabel = wrapper.getAttribute('data-collapse-label') || 'Weniger anzeigen';

      function syncToggleVisibility() {
        const isOverflowing = content.scrollHeight > content.clientHeight + 1;
        const isExpanded = content.classList.contains('is-expanded');

        if (isOverflowing || isExpanded) {
          toggle.hidden = false;
        } else {
          toggle.hidden = true;
          content.classList.remove('is-expanded');
        }
      }

      toggle.addEventListener('click', function () {
        const isExpanded = content.classList.toggle('is-expanded');
        toggle.textContent = isExpanded ? collapseLabel : expandLabel;
        syncToggleVisibility();
      });

      syncToggleVisibility();
      wrapper.dataset.kurzbeschreibungInit = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initKurzbeschreibung();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initKurzbeschreibung(event.target);
  });

  document.addEventListener('product:rerender', function () {
    setTimeout(function () {
      initKurzbeschreibung();
    }, 100);
  });
})();
